module.exports = __webpack_public_path__ + "assets/img/AquavistaGlass-Website.9d25979c.jpg";